'use client'

import { Button } from "@/components/ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { SignOut } from "./sign-out"
import { cn } from "@/lib/utils"

interface UserMenuClientProps {
    user: {
        name?: string | null
        email?: string | null
        image?: string | null
    }
    collapsed?: boolean
}

export function UserMenuClient({ user, collapsed }: UserMenuClientProps) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    className={cn(
                        "w-full justify-start gap-3 px-3 py-2 h-auto",
                        collapsed && "justify-center px-2"
                    )}
                >
                    <Avatar className="h-8 w-8 shrink-0">
                        <AvatarImage src={user.image || ""} alt={user.name || ""} />
                        <AvatarFallback>{user.name?.charAt(0)}</AvatarFallback>
                    </Avatar>
                    {!collapsed && (
                        <div className="flex flex-col items-start text-left overflow-hidden">
                            <span className="text-sm font-medium truncate w-full">{user.name}</span>
                            <span className="text-xs text-muted-foreground truncate w-full">{user.email}</span>
                        </div>
                    )}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="end" forceMount>
                <DropdownMenuLabel className="font-normal">
                    <div className="flex flex-col space-y-1">
                        <p className="text-sm font-medium leading-none">{user.name}</p>
                        <p className="text-xs leading-none text-muted-foreground">
                            {user.email}
                        </p>
                    </div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem asChild>
                    <SignOut />
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
